import {put, takeLatest} from "@redux-saga/core/effects";

import AxiosCustom from "../../../common/components/apiConfig";
import {
    handleNotificationAlertTryUpdate,
    handleNotificationAlertCatch,
    handleNotificationAlertTrySelect
} from "../../../common/method/handleNotificationAlert";


export const actionTypes = {
    selectLivePortfolio: "[selectLivePortfolio] Action",
    selectLivePortfolioLoad: "[selectLivePortfolioLoad] Action",
    selectLivePortfolioAsync: "[selectLivePortfolioAsync] Action",
}


const initialState = {
    data: [],
    loading: false
}

export const select_live_portfolio_reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.selectLivePortfolio:
            return {
                ...state,
                data: payload?.data?.results
            }
        case actionTypes.selectLivePortfolioLoad:
            return {
                ...state,
                loading: payload
            }
        default:
            return state;
    }
}


function* handleWorker({payload}) {
    yield put({type: actionTypes.selectLivePortfolioLoad, payload: true});
    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "select_live_portfolio",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res)

        if(isOk)  yield put({type: actionTypes.selectLivePortfolio, payload: res.data.response})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({type: actionTypes.selectLivePortfolioLoad, payload: false});

    }
}

export function* selectLivePortfolio() {

    yield takeLatest(actionTypes.selectLivePortfolioAsync, handleWorker);
}